// extracted by mini-css-extract-plugin
export default {"wrapper":"FeedHeader_wrapper__dnLQk","container":"FeedHeader_container__Fe+YO"};